/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useUpdateEnrollmentData
 */
import _ from 'lodash';
import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS, { invalidateMetadata } from 'app-constants/queryKeys';

interface IParams {
	payerID: string;
	userModel?: Payers.IUserModelChanges[];
	adminModel?: Payers.IUpdateEnrollmentData[];
}

/**
 * Mutate for useUpdateEnrollmentData
 */
const useUpdateEnrollmentData = (): UseMutationResult<unknown, IAxiosError, IParams, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ payerID, userModel, adminModel }) => {
			if (adminModel && !_.isEmpty(adminModel)) {
				await api.PayersApi.updateEnrollment({ payerId: payerID, enrollmentUpdateModel: adminModel });
			}
			if (userModel && !_.isEmpty(userModel)) {
				await api.PayersApi.patchProviderPayerMeta({ payerId: payerID, providerPayerMetaPatchModel: userModel });
			}
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			invalidateMetadata(queryClient);
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.enrollmentData] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export { IParams };
export default useUpdateEnrollmentData;
